define('lq/stylesheets',[
    'lq',
    'jquery',
    'lq/main',
    'lq/cache'
], function (lq, $, main, Cache) {

    var styleSheetCache = new Cache();
    
    var createId = function(actionId) {
        return 'licquid-customstyles-link-' + actionId;
    };
    
    return {
        
        loadFor: function(actions) {
            return Promise.all(_.map(actions, function(data) {
                if(styleSheetCache.has(data.action.id)) {
                    var actionData = styleSheetCache.get(data.action.id);
                    actionData.counter++;
                    return actionData.promise;
                }
                
                var promise = new Promise((resolve) => {
                    var link = document.createElement('link');
                    link.id = createId(data.action.id);
                    link.type = 'text/css';
                    link.rel = 'stylesheet';
                    link.onload = function () {
                        resolve();
                    };
                    link.href = lq.getTenantUrl('StyleSheet/Get/' + data.action.id + '?v=' + data.action.actionVersion + '-' + data.action.masterPageVersion + '-' + main.getScriptCacheBust());
    
                    $(link)
                        .appendTo("head");
                });
                
                styleSheetCache.set(data.action.id, {
                    promise: promise,
                    counter: 1
                });
                
                return promise;
            }));
        },
        
        unloadFor: function(actionId) {
            var actionData = styleSheetCache.get(actionId);
            actionData.counter--;
            
            if(actionData.counter < 1) {
                styleSheetCache.remove(actionId);
                
                var link = document.getElementById(createId(actionId));
                link.remove();
            }
        }
    };

});
